import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const KEY = "bsn_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product) => {
    setItems((prev) => {
      const found = prev.find((i) => i.lookup_key === product.lookup_key);
      if (found) {
        return prev.map((i) => i.lookup_key === product.lookup_key ? { ...i, qty: i.qty + 1 } : i);
      }
      return [...prev, { ...product, qty: 1 }];
    });
    setOpen(true);
  };

  const remove = (lookup_key) => setItems((prev) => prev.filter((i) => i.lookup_key !== lookup_key));
  const clear = () => setItems([]);

  const count = items.reduce((n, i) => n + i.qty, 0);
  const total = items.reduce((n, i) => n + i.amount * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, clear, count, total, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};
